import React from 'react';
import { Check } from 'lucide-react';

/**
 * Horizontal numbered step indicator for the configurator.
 * `steps` is [{label, done}]. The current step is the first step where done=false.
 */
export default function ConfigProgress({ steps = [] }) {
  if (!steps.length) return null;
  const currentIdx = steps.findIndex((s) => !s.done);
  const effectiveCurrent = currentIdx === -1 ? steps.length : currentIdx;

  return (
    <div className="flex items-center gap-1 overflow-x-auto pb-1" data-testid="config-progress">
      {steps.map((step, i) => {
        const isDone = step.done;
        const isCurrent = i === effectiveCurrent;
        return (
          <React.Fragment key={step.label}>
            <div className="flex items-center gap-2 flex-shrink-0">
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center text-[11px] font-bold transition-all ${
                  isDone
                    ? 'bg-[#334155] text-white'
                    : isCurrent
                    ? 'bg-[#D4A55A] text-white ring-2 ring-[#D4A55A]/30'
                    : 'bg-gray-200 text-gray-500'
                }`}
              >
                {isDone ? <Check className="w-3.5 h-3.5" /> : i + 1}
              </div>
              <span
                className={`text-[11px] font-semibold uppercase tracking-wider whitespace-nowrap ${
                  isDone || isCurrent ? 'text-gray-900' : 'text-gray-400'
                }`}
              >
                {step.label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div
                className={`h-0.5 w-4 flex-shrink-0 ${isDone ? 'bg-[#334155]' : 'bg-gray-200'}`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
